import React, { PureComponent } from 'react';

export default class AvatarBase extends PureComponent {
    render() {
        const className = ['avatar'];

        if (this.props.size) className.push(this.props.size);
        if (this.props.empty) className.push('empty');
        if (this.props.solidImage) className.push('solid-image');
        if (this.props.border) className.push('border');
        if (this.props.dimmed) className.push('dimmed');
        if (this.props.className) className.push(this.props.className);

        const style = {
            backgroundColor: this.props.color
        };

        if (this.props.image) {
            style.backgroundImage = `url('${encodeURI(this.props.image)}')`;
        } else if (this.props.secondaryColor) {
            style.backgroundImage = `linear-gradient(180deg, ${this.props.color} 0%, ${this.props.secondaryColor} 100%)`;
        }

        return (
            <span
                className={className.join(' ')}
                style={style}
                onClick={this.props.onClick}
            >
                {this.props.text}
            </span>
        )
    }
}
